/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react'

export default function UnknownMonoIcon(props) {
  return (
    <svg
      width={props?.size || '25'}
      height={props?.size || '25'}
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4723_2)">
        <path
          d="M250 10C382.548 10 490 117.452 490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10Z"
          fill="#00CACD"
          fillOpacity="0.1"
          stroke="#00CACD"
          strokeWidth="20"
        />
        <path
          d="M250.201 274.226V267.73C250.201 246.691 264.928 235.553 279.654 226.58C294.029 217.917 308.402 206.78 308.402 186.36C308.402 157.896 282.457 135 250.201 135C217.945 135 192 157.896 192 186.36"
          stroke="#00CACD"
          strokeWidth="35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M250.047 348.404H250.355"
          stroke="#00CACD"
          strokeWidth="35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4723_2">
          <rect width="500" height="500" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
